<template>
  <div class="dataTables_wrapper no-footer mtable">
    <div class="datatable-header mtable-tool hui-group-dib-box">
      <seekDatePicker v-if="seekDatePicker" :seekDatePicker="seekDatePicker" @seekDatePicker="seekDatePickerFn" class="pull-left m-r-30 mtable-tool-seek"></seekDatePicker>
      <seek v-if="seekDropdown" @seek="seek" @clickSeekDropdown="clickSeekDropdown" class="pull-left m-r-30 mtable-tool-seek" :seekDropdown="seekDropdownProps"></seek>
      <selPage v-if="selPage" class="pull-right" :multiLanguage="multiLanguage" :selPage="selPage" @selPage="selPageFn"></selPage>
      <div class="btn-group p-0 pull-left mtable-tool-fn">
        <div class="btn btn-default" @click="refresh"><i class="glyphicon glyphicon-refresh tab-he-glyphicon"></i>{{multiLanguage.refreshData}}</div>
        <!-- <jsonExcel v-if="jsonExcelAjax" class="btn btn-default" name="filename.xlsx" :multiLanguage="multiLanguage" :ajaxUrl="jsonExcelAjax.url || false" :ajaxPar="jsonExcelAjax.ajaxPar || false" :ajaxType="jsonExcelAjax.ajaxType" :keys="thData" :ajaxGetKey="jsonExcelAjax.getKey" :colData="Object.keys(totalTr).length > 0?[...jsonExcelAjax.colData, totalTr]:jsonExcelAjax.colData">
          <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>{{multiLanguage.downloadExcelForms}}
        </jsonExcel> -->
        <jsonExcel v-if="jsonExcelAjax" class="btn btn-default" name="filename.xlsx" 
                :ajaxUrl="jsonExcelAjax.url || false" :ajaxPar="jsonExcelAjax.ajaxPar || false" 
                :ajaxType="jsonExcelAjax.ajaxType" :keys="thData" :ajaxGetKey="jsonExcelAjax.getKey" 
                :multiLanguage="multiLanguage"
                :label = "label" :colData="[]">
                  <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>{{multiLanguage.downloadExcelForms}}
              </jsonExcel>

        <!-- leo 这些代码在销售佣金设定页面生效 -->
        <Dropdown ref="dropdown" v-if="!(JSON.stringify(isSetting) === '{}')">
          <button class="btn btn-default select-btn" type="button"  data-role="trigger">
            <span>{{multiLanguage.isSetting[isSetting.listActive]}}</span>
            <span class="caret"></span>
          </button>
          <template slot="dropdown">
            <li><a role="button" @click="dropdownFn($event)">{{multiLanguage.isSetting.checked}}</a></li>
            <li><a role="button" @click="dropdownFn($event)">{{multiLanguage.isSetting.unchecked}}</a></li>
            <li><a role="button" @click="dropdownFn($event)">{{multiLanguage.isSetting.unsated}}</a></li>
            <li><a role="button" @click="dropdownFn($event)">{{multiLanguage.isSetting.allStatus}}</a></li>
          </template>
        </Dropdown>
        <!-- leo 这些代码在销售佣金设定页面生效 -->
        
        <router-link v-if="handle && handle.link === 'accountDatum'" :to="handle.link" class="btn btn-default" :class="{'radius-r': !handle.delete}"><i class="glyphicon glyphicon-new-window tab-he-glyphicon"></i>{{multiLanguage.addAccount}}</router-link>
        <div class="btn btn-default btn-danger mtable-tool-delete" :class="{'radius-r':handle.delete}" v-show="handle.delete && !deleteCol.switch" @click="deleteCol.switch = true">
          <i class="glyphicon glyphicon-trash tab-he-glyphicon"></i>
          {{multiLanguage.deletedData}}
        </div>
        <div class="btn btn-default btn-danger mtable-tool-delete" :class="{'radius-r':handle.delete}" v-show="handle.delete && deleteCol.switch" @click="deleteColNotarizeFn">
          <i class="glyphicon glyphicon-log-out tab-he-glyphicon"></i>
          {{multiLanguage.confirmDelete}}
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="datatable-scroll">
      <slot name="datatable-scroll">
      </slot>
      <table class="table table-bordered table-hover datatable-highlight dataTable no-footer table-striped" id="DataTables_Table_2" role="grid" aria-describedby="DataTables_Table_2_info">
        <thead>
          <tr role="row">
            <th v-for="(item,index) in thData" @click="sortFn(Object.keys(trData[0])[index])" :class="{sorting: sort && index == 0}">{{item}}</th>
            <th v-if="handle" tabindex="0" >{{multiLanguage.th.operation}}</th>
          </tr>
        </thead>
        <tbody  :class="{'deleteCol-opt': handle.delete}">
          <tr role="row" v-show="trData.length > 0" v-for="(item,index) in trData" @click="clickColFn(item, index)" :class="trCls && trCls(item, index)">
            <td class="sorting_1" :class="{'pointer': deleteCol.switch}" v-for="key in trDataKeys" @click="deletePitch(item)">
              <!-- leo 这些代码在销售佣金设定页面生效 -->
              <span v-if="key == 'officeState' && item[key] == 'F'">{{multiLanguage.th.officeState.countryArr[0].text}}</span>
              <span v-else-if="key == 'officeState' && item[key] == 'P'">{{multiLanguage.th.officeState.countryArr[1].text}}</span>
              <span v-else-if="key == 'officeState' && item[key] == 'D'">{{multiLanguage.th.officeState.countryArr[2].text}}</span>
              <span v-else-if="key == 'status' && item[key] == 0 ">{{multiLanguage.isSetting.unsated}}</span>
              <span v-else-if="key == 'status' && item[key] == 1 ">{{multiLanguage.isSetting.unchecked}}</span>
              <span v-else-if="key == 'status' && item[key] == 2 ">{{multiLanguage.isSetting.checked}}</span>
              <!-- leo 这些代码在销售佣金设定页面生效 -->
              <span v-else-if="key == 'last_update'">{{momentFn(item[key])}}</span>
              <span v-else>{{item[key]}}</span>
            </td>
            <td v-if="handle" class="text-center pointer" :class="{'pointer': deleteCol.switch}" @click="linkRegister(item)">
              <i v-show="!deleteCol.switch" class="icon-compose"></i>
              <i v-show="deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) != -1" class="glyphicon glyphicon-ok color-red"></i>
              <i v-show="deleteCol.switch && deleteCol.list.indexOf(item[handle.idKey]) == -1" class="glyphicon glyphicon-trash tab-he-glyphicon"></i>
            </td>
          </tr>
          <tr v-if="trData.length > 0 && Object.keys(totalTr).length > 0">
            <td v-for="item in totalTr">{{item}}</td>
          </tr>
        </tbody>
      </table>
      <noData v-if="trData.length==0" :text="multiLanguage.nodata" :fontSize="'18'"></noData>
    </div>
    <div class="datatable-footer" v-if="selPage">
      <div class="dataTables_info" id="DataTables_Table_2_info" role="status" aria-live="polite">
        {{multiLanguage.clauses}}{{multiLanguage.amount}}:&nbsp;{{page.pageLeng}}&nbsp;&nbsp;{{multiLanguage.present}}:&nbsp;{{page.active*selPage.limit-selPage.limit+1}}-{{Math.min(page.active*selPage.limit,page.pageLeng)}}
      </div>
      <div v-if="Math.ceil(page.pageLeng/selPage.list[selPage.active])" class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_2_paginate">
        <pagination v-model="pageactive" :boundary-links="true" :direction-links="true" :total-page="Math.ceil(page.pageLeng/selPage.list[selPage.active])" :max-size="page.pagenum" @change="callpageFn"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { getTimeDiff,updateTimeByUtc } from 'common/js/util'
  import seek from "components/commissionSeek"
  import selPage from "components/selPage"
  import seekDatePicker from "components/seekDatePicker"
  import noData from "components/noData"
  import fileUpload from "vue-upload-component"
  import { Dropdown, Pagination } from "uiv"
  import jsonExcel from "components/commissionJsonExcel"
  import { mapMutations } from "vuex"
  import { Api } from 'api/commissionEnv'
  var api = new Api()

  export default {
    props: {
      isSetting: {
        type: Object,
        default: {}
      },
      thData: {  // 表格th数据
        type: Array,
        default: []
      },
      trData: {},  // 表格tr数据
      totalData: {
        default: false
      },
      handle: {
        default: false
      },
      multiLanguage: {  // 翻译，也是文字型数据
        type: Object,
        default: {}
      },
      selPage: {  // 显示条目数
        default: false
      },
      seekDropdown: {  // 搜索目标选项
        default: false
      },
      page: {  // 分页
        default: false
      },
      jsonExcelAjax: {  // 下载Excel
        default: false
      },
      sort: {  // 排序
        default: false
      },
      seekDatePicker: {  // 时间搜索
        default: false
      },
      trCls: {  // tr class
        default: false
      },
      region: {
        defalut: false
      },
      label: {
        defalut: false
      }
    },
    data () {
      return {
        pageactive: this.page ? this.page.active : "",
        seekDropdownProps: this.seekDropdown ? this.seekDropdown : "",
        deleteCol: {  // 删除功能
          switch: false,
          list: []
        },
        totalTr: {}
      }
    },
    mounted () {
      this.totalData && this.total()
      if (this.selPage && !this.selPage.active) this.$parent.selPage.active = 0
    },
    computed: {
      trDataKeys () {
        return Object.keys(this.trData[0])
      }
    },
    methods: {
      momentFn (date) { // 格式化时间 updateTimeByUtc getTimeDiff
        let newDate = updateTimeByUtc(getTimeDiff(),date)
        return newDate
      },
      // 是否設定
      dropdownFn (e) {
        if (e.target.innerHTML == this.multiLanguage.isSetting.checked) {
          this.isSetting.active = 2
          this.isSetting.listActive = 'checked'
        }
        else if (e.target.innerHTML == this.multiLanguage.isSetting.unchecked) {
          this.isSetting.active = 1
          this.isSetting.listActive = 'unchecked'
        }
        else if (e.target.innerHTML == this.multiLanguage.isSetting.unsated) {
          this.isSetting.active = 0
          this.isSetting.listActive = 'unsated'
        } 
        else {
          this.isSetting.active = null
          this.isSetting.listActive = 'allStatus'
        }
        this.$emit("tableChange")
      },
      total () {
        if (!this.totalData || !this.totalData.length) return
        let keys = Object.keys(this.totalData[0])
        let obj = {}
        this.totalData.forEach((item) => {
          keys.forEach((key, keyIndex) => {
            if (Object.prototype.toString.call(item[key]) === "[object Number]" && keyIndex !== 0) {
              if (!obj[key] && obj[key] !== 0) obj[key] = 0
              obj[key] += item[key]
            } else if (Object.prototype.toString.call(item[key]) === "[object String]") {
              obj[key] = "#"
            } else if (keyIndex === 0) {
              obj[key] = this.multiLanguage.total
            }
          })
        })
        Object.keys(obj).forEach(key => {
          if (Object.prototype.toString.call(obj[key]) === "[object Number]") {
            obj[key] = +obj[key].toFixed(2)
          }
        })
        this.totalTr = obj
      },
      sortFn (key) {
        if (!this.sort || this.$parent.sort.key !== key) return
        if (this.sort.method === "ASC") {
          this.$parent.sort.method = "DESC"
        } else if (this.sort.method === "DESC") {
          this.$parent.sort.method = "ASC"
        }
        this.$emit("tableChange")
      },
      clickSeekDropdown (index) {
        this.$emit("clickSeekDropdown", index)
      },
      selPageFn (index, item) {
        this.SAVEPAGEMAXINDEX(index)
        this.$parent.selPage.active = index
        this.$parent.selPage.limit = this.selPage.list[this.selPage.active]
        this.$parent.page.offset = 0
        this.pageactive = 1
        this.$parent.page.active = 1
        this.$emit("tableChange")
      },
      callpageFn (index) {
        this.$parent.page.active = index
        this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : ""
        this.$emit("tableChange")
      },
      setSeekDropdown (index) {
        this.seekDropdownActive = index
      },
      refresh () {
        if (this.$parent.page) this.$parent.page.active = 1
        if (this.$parent.page) this.pageactive = 1
        if (this.$parent.page) this.$parent.page.offset = 0
        if (this.$parent.seekDropdown) this.$parent.seekDropdown.seekStr = ""
        this.$emit("tableChange")
      },
      seek (seekStr) {
        this.pageactive = 1
        if (this.page) this.$parent.page.offset = 0
        if (this.$parent.page) this.$parent.page.active = 1
        this.$emit("seek")
      },
      seekDatePickerFn (seekVal) {
        this.$emit("seek")
      },
      clickColFn (colItem, index) {
        this.$emit("clickCol", colItem, index)
      },
      deleteColClick () {
        this.deleteCol.switch = true
      },
      deleteColNotarizeFn () {
        this.deleteCol.switch = false
        this.$emit("deleteList", this.deleteCol.list)
        this.deleteCol.list = []
      },
      deletePitch (item) {
        if (this.deleteCol.switch === false) {
          return
        }
        let id = item[this.handle.idKey]
        let index = this.deleteCol.list.indexOf(id)
        if (index === -1) {
          this.deleteCol.list.push(id)
        } else {
          this.deleteCol.list.splice(index, 1)
        }
      },
      linkRegister (item) {
        if (this.deleteCol.switch === true) {
          this.deletePitch(item)
        } else {
          this.$router.push({
            path: this.handle.link,
            query: {
              id: item[this.handle.idKey],
              region: this.region
            }
          })
        }
      },
      ...mapMutations(["SAVEPAGEMAXINDEX"])
    },
    watch: {
      seekDropdownActive (curVal, oldVal) {
        this.$parent.seekData.seekDropdownActive = curVal
      },
      totalData (curVal, oldVal) {
        curVal.length > 0 && this.total()
      }
    },
    components: {
      seek,
      selPage,
      seekDatePicker,
      fileUpload,
      Dropdown,
      Pagination,
      jsonExcel,
      noData
    }
  }
</script>

<style lang="scss" scoped type="text/scss" >
  .mtable{
    .datatable-scroll{
      .table{
        thead{
          border-top: 1px solid #ddd;
          tr{
            background-color: #EBEDF7;
          }
        }
      }
    }
    .mtable-tool{
      padding: 0 20px 25px;
      border-bottom: 0;
      .mtable-tool-seek,.mtable-tool-selPage,.mtable-tool-fn {
        padding-top: 20px;
        line-height: 36px;
      }
      .mtable-tool-fn {
        .radius-r{
          border-top-right-radius: 3px !important;
          border-bottom-right-radius: 3px !important;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// sTable.vue?57acf00b